import { render, staticRenderFns } from "./DepartementoHeader.vue?vue&type=template&id=36d6844e"
import script from "./DepartementoHeader.vue?vue&type=script&lang=js"
export * from "./DepartementoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports